import React from 'react';
import TeamBlock from '../components/ConsultancyElements/TeamBlock';

const TeamPageContainer = () => {
    const TeamPageData = [
        {
            id: '1',
            img: 'images/team/1.jpg',
            tag: 'Founder & Managing Director',
            name: 'Deodutta Roy',
             facebook: 'https://www.facebook.com/',
            instagram: 'https://www.instagram.com/',
            twitter: 'https://x.com/',
            linkedin: 'https://www.linkedin.com/in/deepdoon/'
        },
        {
            id: '2',
            img: 'images/team/deepak.png',
            tag: 'Technical Consultant',
            name: 'Deepak Dhiman',
             facebook: 'https://www.facebook.com/',
            instagram: 'https://www.instagram.com/',
            twitter: 'https://x.com/',
            linkedin: 'https://www.linkedin.com/in/deepdoon/'
        },
        {
            id: '3',
            img: 'images/team/3.jpg',
            tag: 'Technical Consultant',
            name: 'Pankaj',
             facebook: 'https://www.facebook.com/',
            instagram: 'https://www.instagram.com/',
            twitter: 'https://x.com/',
            linkedin: 'https://www.linkedin.com/in/deepdoon/'
        },
        {
            id: '4',
            img: 'images/team/4.jpg',
            tag: 'Consultant',
            name: 'Garrison Hall',
             facebook: 'https://www.facebook.com/',
            instagram: 'https://www.instagram.com/',
            twitter: 'https://x.com/',
            linkedin: 'https://www.linkedin.com/in/deepdoon/'
        },
        {
            id: '5',
            img: 'images/team/5.jpg',
            tag: 'Consultant',
            name: 'Oakland Miller',
             facebook: 'https://www.facebook.com/',
            instagram: 'https://www.instagram.com/',
            twitter: 'https://x.com/',
            linkedin: 'https://www.linkedin.com/in/deepdoon/'
        },
        {
            id: '6',
            img: 'images/team/6.jpg',
            tag: 'Consultant',
            name: 'Helen Mirren',
             facebook: 'https://www.facebook.com/',
            instagram: 'https://www.instagram.com/',
            twitter: 'https://x.com/',
            linkedin: 'https://www.linkedin.com/in/deepdoon/'
        },
    ];

    return (
        <section className="team-section">
            <div className="container">
                <div className="inner-column">
                    <div className="row clearfix">
                        {
                            TeamPageData.map(data => <TeamBlock
                                key={data.id}
                                data={data}
                            />)
                        }

                    </div>
                </div>
            </div>
        </section>
    );
};

export default TeamPageContainer;